import React, {useEffect} from 'react';
// import { useData } from '../../hooks/useData';
import dynamic from 'next/dynamic';
const Breadcrumbs = dynamic(() => import("../../components/breadcrumbs"));
const Card = dynamic(() => import("../../components/card"));
import sanityClient from "../../../public/support-func/sanityClient";
import Head from 'next/head';
import { sortByDate } from '../../../public/support-func/support.js';
// import BlockPagination from '../../components/block-pagination';
// сделать подгрузку при скролле
const Flowers = dynamic(() => import("../../components/flowers"));

export async function getStaticProps() {
    const pageMeta = await sanityClient.fetch(`*[_type == "metadata" && title == "/stories"] `);
    const pageData = await sanityClient.fetch(`*[_type == "stories" && active == true]`);
    const categories = await sanityClient.fetch(`*[_type == "categories" && activeCategory == true]`);
  
    return {
      props: { 
        pageMeta: pageMeta[0],
        pageData,
        categories
      },
      revalidate: 300
    };
  };

const AllStories = ({pageMeta, pageData, categories}) => {
    // const { peronalsArray } = useData();
    // const [currentPage, setCurrentPage] = useState(1);
    // const [pageNumber, setPageNumber] = useState(1);
    // const [postPerPage] = useState(6)

    // const lastPostIndex = currentPage * postPerPage;
    // const firstPostIndex = lastPostIndex - postPerPage;
    // const currentItems = pageData?.slice(firstPostIndex, lastPostIndex);

    useEffect(() => {
      window.scrollTo(0, 0);
        // setPageNumber(Math.ceil(pageData?.length / postPerPage))
      document.querySelector('.flower_container_two')?.classList.add('none');
      document.querySelector('.flower_container_three')?.classList.add('none');
    }, [])

    return (
        <>
            <Head>
                <title>{ pageMeta.meta_title }</title>
                <meta name="description" content={pageMeta.meta_description} />
                <meta name="keywords" content={pageMeta.meta_keywords} />

            </Head>

            <Breadcrumbs pathArr={[{name: "Рассказы", url: "/stories",}]} />
            <Flowers />
            <h1 className='accent_text'>Все рассказы</h1>
            
            <section className='section story_cards'>
                {sortByDate(pageData)?.map((item: any) => {
                  return <Card 
                    key={item._id}
                    title={item.title}
                    text={item.shortDescription}
                    linkToStory={`/stories/${item.slug.current}`}
                    linkToCategory={`/categories/${categories.find(i => i._id === item.category._ref)?.slug.current}`}
                  />
                })}
            </section>
            
            {/* {
                pageNumber > 1 &&  
                <BlockPagination 
                    pageCount={pageNumber}
                    setPage={setCurrentPage}
                    currentPage={currentPage}
                />
            } */}
        </>
    )
}

export default AllStories;